import React from 'react';

import { formatNumber } from '../../utils/formats';

// SVG LOGOS
import brokenImg from '../../assets/img/broken-image-general.png';
import belmenySvg from '../../assets/img/logos/BELMENY-SVG.svg';
import ingcoSvg from '../../assets/img/logos/INGCO-SVG.svg';
import vertSvg from '../../assets/img/logos/VERT-SVG.svg';
import quilosaSvg from '../../assets/img/logos/QUILOSA-SVG.svg';
import fleximaticSvg from '../../assets/img/logos/FLEXIMATIC-SVG.svg';
import imouSvg from '../../assets/img/logos/IMOU-SVG.svg';
import coronaSvg from '../../assets/img/logos/CORONA-SVG.svg';
import wadfowSvg from '../../assets/img/logos/WADFOW-SVG.svg';

export const TopProductos = ({ topProductos = [] }) => {
  const handleImageError = (event) => {
    event.target.src = brokenImg;
  };

  // Suma total para % (protegida si no hay datos)
  const sumTotalVendido = (topProductos || []).reduce((acc, productos) => {
    const totalVendidoVert = productos.TotalVendidoVert || 0;
    const totalVendidoIngco = productos.TotalVendidoIngco || 0;
    const totalVendidoImou = productos.TotalVendidoImou || 0;
    const totalVendidoWadfow = productos.TotalVendidoWadfow || 0;
    const totalVendidoCorona = productos.TotalVendidoCorona || 0;
    const totalVendidoFleximatic = productos.TotalVendidoFleximatic || 0;
    const totalVendidoQuilosa = productos.TotalVendidoQuilosa || 0;
    return acc + totalVendidoVert + totalVendidoIngco + totalVendidoImou + totalVendidoWadfow + totalVendidoCorona + totalVendidoFleximatic + totalVendidoQuilosa;
  }, 0);

  const pct = (value) => {
    if (!sumTotalVendido || sumTotalVendido === 0) return '0.00';
    return ((Number(value || 0) * 100) / sumTotalVendido).toFixed(2);
  };

  const vendorTotal = (v) =>
    (v.TotalVendidoVert || 0) +
    (v.TotalVendidoIngco || 0) +
    (v.TotalVendidoImou || 0) +
    (v.TotalVendidoWadfow || 0) +
    (v.TotalVendidoCorona || 0) +
    (v.TotalVendidoFleximatic || 0) +
    (v.TotalVendidoQuilosa || 0);

  // Componente fila compacta para mobile
  const BrandRowMobile = ({ logo, name, cantidad, ventas, porcentaje }) => (
    <div className="mobile-brand d-flex align-items-center bg-white rounded p-2 mb-2">
      <div style={{ width: 64, flexShrink: 0 }}>
        <img src={logo} alt={name} onError={handleImageError} style={{ width: 56, height: 'auto' }} />
      </div>
      <div style={{ flex: 1, paddingLeft: 12 }}>
        <div className="d-flex justify-content-between align-items-baseline">
          <div style={{ fontWeight: 700 }}>{name}</div>
          <div className="text-success fw-bold">${formatNumber(Number(ventas || 0).toFixed(2))}</div>
        </div>
        <div className="d-flex justify-content-between small text-muted">
          <div>{cantidad || 0} productos</div>
          <div>{porcentaje}%</div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="row">
        <div className="col">

          {/* =================== DESKTOP: conserva EXACTAMENTE tu diseño original =================== */}
          <div className="d-none d-md-block">
            <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
              <h4 className="text-belmeny mb-3">Ventas por marca</h4>
              <h5 className="text-belmeny mb-3">
                Total vendido en el mes: <span className="text-success fw-bold">${formatNumber(sumTotalVendido.toFixed(2))}</span>
              </h5>
              <h6 className="text-muted fw-normal mb-3">
                Para poder visualizar los datos haga click en el gerente que desea ver y la tarjeta se expandirá
              </h6>

              <div className="container-fluid h-100">
                <div className="accordion mt-2" id="accordionVxC">
                  {
                    topProductos.map((vxc, idx) =>
                      <div className="accordion-item" key={vxc.CodSupervisor ?? idx}>
                        <h2 className="accordion-header" id={`heading${vxc.CodSupervisor}`}>
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${vxc.CodSupervisor}`} aria-expanded="false" aria-controls={`collapse${vxc.CodSupervisor}`}>
                            {
                              (vxc.CodSupervisor === "S01") ? <span>{vxc.CodSupervisor} - Lissette Nuñez</span> :
                                (vxc.CodSupervisor === "S02") ? <span>{vxc.CodSupervisor} - Luis Sastre</span> :
                                  (vxc.CodSupervisor === "S03") ? <span>{vxc.CodSupervisor} - Javier Villasmil</span> :
                                    (vxc.CodSupervisor === "S04") ? <span>{vxc.CodSupervisor} - Adel Codallo</span> :
                                      <span>{vxc.CodSupervisor} - {vxc.Nombre || 'Supervisor'}</span>
                            }
                          </button>
                        </h2>
                        <div id={`collapse${vxc.CodSupervisor}`} className="accordion-collapse collapse" aria-labelledby={`heading${vxc.CodSupervisor}`} data-bs-parent="#accordionVxC">
                          <div className="accordion-body">
                            <div className="row bg-belmeny3 text-white py-3 rounded">
                              <div className="col-3">
                                <h5 className="text-uppercase">Marca</h5>
                              </div>
                              <div className="col">
                                <h5 className="text-uppercase text-center">Productos Vendidos</h5>
                              </div>
                              <div className="col">
                                <h5 className="text-uppercase text-center">Ventas Generadas</h5>
                              </div>
                              <div className="col">
                                <h5 className="text-uppercase text-center">% Representado</h5>
                              </div>
                            </div>

                            {/* VERT */}
                            <div className="row mt-3">
                              <div className="col-3">
                                <h5 className="text-uppercase pt-1">
                                  <img src={vertSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal">
                                  {(vxc.CantidadProductosVert === null || vxc.CantidadProductosVert === 0) ? 0 : vxc.CantidadProductosVert}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                  {(vxc.TotalVendidoVert === null || vxc.TotalVendidoVert === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoVert).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                  {(vxc.TotalVendidoVert === null || vxc.TotalVendidoVert === 0) ? 0 : pct(vxc.TotalVendidoVert)}%
                                </h5>
                              </div>
                            </div>

                            {/* INGCO */}
                            <div className="row mt-3">
                              <div className="col-3">
                                <h5 className="text-uppercase">
                                  <img src={ingcoSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-2 fw-normal">
                                  {(vxc.CantidadProductosIngco === null || vxc.CantidadProductosIngco === 0) ? 0 : vxc.CantidadProductosIngco}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-2 fw-normal text-success">
                                  {(vxc.TotalVendidoIngco === null || vxc.TotalVendidoIngco === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoIngco).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-2 fw-normal text-info">
                                  {(vxc.TotalVendidoIngco === null || vxc.TotalVendidoIngco === 0) ? 0 : pct(vxc.TotalVendidoIngco)}%
                                </h5>
                              </div>
                            </div>

                            {/* QUILOSA */}
                            <div className="row mt-3">
                              <div className="col-3">
                                <h5 className="text-uppercase">
                                  <img src={quilosaSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal">
                                  {(vxc.CantidadProductosQuilosa === null || vxc.CantidadProductosQuilosa === 0) ? 0 : vxc.CantidadProductosQuilosa}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                  {(vxc.TotalVendidoQuilosa === null || vxc.TotalVendidoQuilosa === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoQuilosa).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                  {(vxc.TotalVendidoQuilosa === null || vxc.TotalVendidoQuilosa === 0) ? 0 : pct(vxc.TotalVendidoQuilosa)}%
                                </h5>
                              </div>
                            </div>

                            {/* IMOU */}
                            <div className="row mt-3">
                              <div className="col-3">
                                <h5 className="text-uppercase pt-1">
                                  <img src={imouSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal">
                                  {(vxc.CantidadProductosImou === null || vxc.CantidadProductosImou === 0) ? 0 : vxc.CantidadProductosImou}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                  {(vxc.TotalVendidoImou === null || vxc.TotalVendidoImou === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoImou).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                  {(vxc.TotalVendidoImou === null || vxc.TotalVendidoImou === 0) ? 0 : pct(vxc.TotalVendidoImou)}%
                                </h5>
                              </div>
                            </div>

                            {/* FLEXIMATIC */}
                            <div className="row mt-3">
                              <div className="col-3">
                                <h5 className="text-uppercase pt-1">
                                  <img src={fleximaticSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal">
                                  {(vxc.CantidadProductosFleximatic === null || vxc.CantidadProductosFleximatic === 0) ? 0 : vxc.CantidadProductosFleximatic}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                  {(vxc.TotalVendidoFleximatic === null || vxc.TotalVendidoFleximatic === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoFleximatic).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                  {(vxc.TotalVendidoFleximatic === null || vxc.TotalVendidoFleximatic === 0) ? 0 : pct(vxc.TotalVendidoFleximatic)}%
                                </h5>
                              </div>
                            </div>

                            {/* CORONA */}
                            <div className="row mt-3">
                              <div className="col-3">
                                <h5 className="text-uppercase pt-1">
                                  <img src={coronaSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-3 fw-normal">
                                  {(vxc.CantidadProductosCorona === null || vxc.CantidadProductosCorona === 0) ? 0 : vxc.CantidadProductosCorona}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-3 fw-normal text-success">
                                  {(vxc.TotalVendidoCorona === null || vxc.TotalVendidoCorona === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoCorona).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-3 fw-normal text-info">
                                  {(vxc.TotalVendidoCorona === null || vxc.TotalVendidoCorona === 0) ? 0 : pct(vxc.TotalVendidoCorona)}%
                                </h5>
                              </div>
                            </div>

                            {/* WADFOW */}
                            <div className="row mt-4">
                              <div className="col-3">
                                <h5 className="text-uppercase pt-2">
                                  <img src={wadfowSvg} width={120} alt="No se ha podido cargar la imagen..." onError={handleImageError} />
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-3 fw-normal">
                                  {(vxc.CantidadProductosWadfow === null || vxc.CantidadProductosWadfow === 0) ? 0 : vxc.CantidadProductosWadfow}
                                  <span className="ps-1">Productos</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-3 fw-normal text-success">
                                  {(vxc.TotalVendidoWadfow === null || vxc.TotalVendidoWadfow === 0) ? 0 : formatNumber(Number(vxc.TotalVendidoWadfow).toFixed(2))}
                                  <span className="ps-1">USD</span>
                                </h5>
                              </div>
                              <div className="col">
                                <h5 className="text-center text-uppercase pt-3 fw-normal text-info">
                                  {(vxc.TotalVendidoWadfow === null || vxc.TotalVendidoWadfow === 0) ? 0 : pct(vxc.TotalVendidoWadfow)}%
                                </h5>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </div>

          {/* =================== MOBILE: vista apilada y legible =================== */}
          <div className="d-block d-md-none">
            <style>{`
              .topproductos-mobile .vendedor-card { margin-bottom: 12px; }
              .topproductos-mobile .vendedor-header { font-weight: 700; margin-bottom: 8px; }
              .topproductos-mobile .mobile-brand { transition: box-shadow .12s ease; }
              .topproductos-mobile .mobile-brand:hover { box-shadow: 0 6px 18px rgba(0,0,0,0.06); transform: translateY(-2px); }
            `}</style>

            <div className="topproductos-mobile">
              <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
                <h4 className="text-belmeny mb-2">Ventas por marca</h4>
                <h5 className="text-belmeny mb-2">Total vendido en el mes: <span className="text-success fw-bold">${formatNumber(sumTotalVendido.toFixed(2))}</span></h5>
                <h6 className="text-muted fw-normal mb-3">Para ver el detalle toca el supervisor</h6>

                {topProductos && topProductos.length ? (
                  topProductos.map((vxc, idx) => (
                    <div className="vendedor-card" key={vxc.CodSupervisor ?? idx}>
                      <div className="bg-light rounded p-2 mb-2 d-flex justify-content-between align-items-center">
                        <div className="vendedor-header">
                          {(vxc.CodSupervisor === "S01") ? `${vxc.CodSupervisor} - Lissette Nuñez`
                            : (vxc.CodSupervisor === "S02") ? `${vxc.CodSupervisor} - Luis Sastre`
                              : (vxc.CodSupervisor === "S03") ? `${vxc.CodSupervisor} - Javier Villasmil`
                                : (vxc.CodSupervisor === "S04") ? `${vxc.CodSupervisor} - Adel Codallo`
                                  : `${vxc.CodSupervisor} - ${vxc.Nombre || 'Supervisor'}`}
                        </div>
                        <div className="text-muted small">{formatNumber(vendorTotal(vxc).toFixed(2))} USD</div>
                      </div>

                      {/* Brands compactas */}
                      <BrandRowMobile
                        logo={vertSvg}
                        name="VERT"
                        cantidad={vxc.CantidadProductosVert || 0}
                        ventas={vxc.TotalVendidoVert || 0}
                        porcentaje={pct(vxc.TotalVendidoVert)}
                      />
                      <BrandRowMobile
                        logo={ingcoSvg}
                        name="INGCO"
                        cantidad={vxc.CantidadProductosIngco || 0}
                        ventas={vxc.TotalVendidoIngco || 0}
                        porcentaje={pct(vxc.TotalVendidoIngco)}
                      />
                      <BrandRowMobile
                        logo={quilosaSvg}
                        name="QUILOSA"
                        cantidad={vxc.CantidadProductosQuilosa || 0}
                        ventas={vxc.TotalVendidoQuilosa || 0}
                        porcentaje={pct(vxc.TotalVendidoQuilosa)}
                      />
                      <BrandRowMobile
                        logo={imouSvg}
                        name="IMOU"
                        cantidad={vxc.CantidadProductosImou || 0}
                        ventas={vxc.TotalVendidoImou || 0}
                        porcentaje={pct(vxc.TotalVendidoImou)}
                      />
                      <BrandRowMobile
                        logo={fleximaticSvg}
                        name="FLEXIMATIC"
                        cantidad={vxc.CantidadProductosFleximatic || 0}
                        ventas={vxc.TotalVendidoFleximatic || 0}
                        porcentaje={pct(vxc.TotalVendidoFleximatic)}
                      />
                      <BrandRowMobile
                        logo={coronaSvg}
                        name="CORONA"
                        cantidad={vxc.CantidadProductosCorona || 0}
                        ventas={vxc.TotalVendidoCorona || 0}
                        porcentaje={pct(vxc.TotalVendidoCorona)}
                      />
                      <BrandRowMobile
                        logo={wadfowSvg}
                        name="WADFOW"
                        cantidad={vxc.CantidadProductosWadfow || 0}
                        ventas={vxc.TotalVendidoWadfow || 0}
                        porcentaje={pct(vxc.TotalVendidoWadfow)}
                      />
                    </div>
                  ))
                ) : (
                  <div className="text-muted">Sin datos para mostrar.</div>
                )}

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};
